import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import Pagination from "../../../../../components/pagination";

TimeAgo.addLocale(en);
const ReactTimeAgo = new TimeAgo('en-US');

const MobileProducts = ({ data }) => {

    let SIZE = 3;
    const [currentPage, setCurrentPage] = useState(1);
    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * SIZE;
        const lastPageIndex = firstPageIndex + SIZE;
        return data.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, data]);

    if(!data.length) {
        return null;
    }

    return (
        <div>
            {currentTableData.map((item, key) => {

                const { outcome, feedback_id, created_at, reason } = item;

                return <div className="table-mobile-card" key={key}>

                    <div className="table-mobile-card-header">
                        <div className="d-flex">
                            <div className="table-mobile-card-header-main">
                                <Link to="/appeals">{feedback_id}</Link>
                                <div>{ReactTimeAgo.format((created_at || 1) * 1000)}</div>
                            </div>
                        </div>

                    </div>

                    <div className="table-mobile-card-body">
                        <div className="table-mobile-card-body-list">
                            <div><div>Reason</div><div>
                                <div className="badge badge-confirmation">{(reason || "").toLowerCase().replaceAll("_", " ")}</div>
                            </div></div>
                            <div>
                                <div>Outcome</div>
                                <div>
                                    <div className={`badge badge-${outcome}`}>{(outcome || "").toLowerCase().replaceAll("_", " ")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            })}

            <Pagination
                currentPage={currentPage}
                totalCount={data.length}
                pageSize={SIZE}
                onPageChange={setCurrentPage}
            />

        </div>
    );
};

export default MobileProducts;
